module.exports = __webpack_public_path__ + "img/icon_link_checked@3x.c9eeaa4.png";